/**
 * shopify-i18n.js — Toggle FR/EN autonome pour Shopify.
 * Généré depuis src/i18n/dictionary.ts par scripts/build-shopify-i18n.mjs
 * Ne PAS éditer à la main : regénérer via "node scripts/build-shopify-i18n.mjs".
 *
 * Installation Shopify :
 *   1) Online Store → Themes → Edit code → Assets → Add a new asset → upload ce fichier
 *   2) Dans layout/theme.liquid, juste avant </body> :
 *        <script src="{{ 'shopify-i18n.js' | asset_url }}" defer></script>
 *   3) Un bouton FR/EN s'affiche en bas à droite. La langue est mémorisée en localStorage.
 */

(function () {
  "use strict";
  var TRANSLATIONS = {
  // ----- Navbar / brand -----
  "L'ÉPOPÉE DU FIL": "CÉCILE HADJIAN",
  "L'Épopée du Fil": "Cécile Hadjian",
  "Accueil": "Home",
  "Œuvres": "Services",
  "Qui suis-je": "About Me",
  "Savoir-Faire": "Craftsmanship",
  "Matières": "Materials",
  "Contact": "Contact",
  "Prendre rendez-vous": "Book an appointment",

  // ----- Hero (Index) -----
  "Tableaux d'Art en Broderie Mécanique": "High-end digital embroidery",
  "Là où l'art du dessin rencontre l'ingénierie textile.":
    "Where the art of design meets the exacting standards of haute couture.",
  "Chaque œuvre, une architecture de fils précieux.":
    "Each creation is a work of precision embroidery for professionals who refuse to compromise.",

  // ----- Inspiration -----
  "L'Inspiration": "Your Vision",
  "Une Fenêtre Ouverte": "Rare Expertise,",
  "sur le Sacré et l'Histoire": "Devoted to Your Creations",

  // ----- ValueProposition -----
  "La Technique": "The Technique",
  "Peindre avec le Fil :": "Designing with Thread:",
  "Une Prouesse Technique": "A Comprehensive Master's Program",

  // ----- ImpactNumber -----
  "Le temps de l'excellence": "A Time of Excellence",
  "à": "to",
  "heures de création par pièce": "hours worked per project",
  "Chaque œuvre est unique, signée et accompagnée de son certificat d'authenticité. Plus de 90 couleurs de fils précieux composent une seule pièce.":
    "Every project is treated with the same level of care. Sometimes more than 90 thread colors are needed, sometimes just two — it all depends on the custom digitization process, which ensures the highest possible quality every single time.",

  // ----- MaterialsOrigin (Index) -----
  "Technique & Matières": "Technique & Materials",
  "Maîtriser la Matière": "Mastering the Material",
  "pour Sublimer l'Œuvre": "to Elevate the Work",
  "L'Excellence des Matières": "The Excellence of Materials",
  "Pour obtenir une profondeur inégalée, je compose avec des fils sourcés mondialement : l'éclat des fils métalliques japonais, le soyeux de la viscose allemande et la noblesse du coton italien.":
    "To achieve a result worthy of haute couture, I select threads sourced from around the world: the luster of Japanese metallic threads, the silkiness of German viscose, and the elegance of Italian cotton. Each thread is chosen for what it will bring to your fabric and your design.",
  "Sculpter la Lumière": "Sculpting Light",
  "Grâce à l'utilisation de plus de 90 couleurs et de fils aux propriétés différentes (mats, brillants, métallisés), l'œuvre capte la lumière naturelle. Le tableau est vivant : il change d'aspect et de vibrance selon l'heure du jour.":
    "With over 90 colors and threads featuring different finishes — matte, glossy, and metallic — the embroidery captures and plays with natural light. Your room transforms and comes alive depending on the time of day and the lighting.",
  "Textures & Reliefs": "Textures & Reliefs",
  "Je ne remplis pas, je sculpte. En variant les techniques de points et les épaisseurs de fil, je recrée le grain de la peau, la froideur du métal ou la fibre des végétaux. J'incruste également du liège et des tissus texturés, rebrodés pour un relief 3D saisissant.":
    "I don't just fill in; I sculpt. By varying my stitching techniques and thread thicknesses, I recreate the texture of skin, the coolness of metal, or the grain of plant fibers. I also incorporate cork and textured fabrics, embroidered to create a striking 3D effect.",

  // ----- SavoirFaire (Index) -----
  "Le Processus": "The Process",
  "De la Main": "From Drawing",
  "à la Machine": "to Embroidery",

  // ----- WhyChooseMe -----
  "Pourquoi me choisir": "Why Choose Me",
  "Ce que vous gagnez": "What you actually",
  "concrètement": "get",
  "Une vision préservée de bout en bout": "A consistent vision from start to finish",
  "Dessinatrice et brodeuse, je suis votre seule interlocutrice. Votre motif ne se dilue pas entre plusieurs prestataires et il arrive tel que vous l'avez imaginé.":
    "As a designer and embroiderer, I am your sole point of contact. Your design won't get lost among multiple service providers — it will turn out exactly as you envisioned it.",
  "Zéro mauvaise surprise": "No unpleasant surprises",
  "15 ans d'expérience sur des matières exigeantes, c'est anticiper les problèmes avant qu'ils n'arrivent. Moins de retouches, moins de pertes, des pièces conformes dès la première réalisation.":
    "15 years of experience with demanding materials means anticipating problems before they arise. Fewer corrections, less waste, pieces that meet the brief from the very first run.",
  "Votre marque se différencie": "Your brand stands out",
  "Une broderie conçue sur mesure, c'est une identité visuelle que personne d'autre ne possède.":
    "A bespoke embroidery gives you a visual identity no one else can own.",

  // ----- Footer -----
  "Chaque pièce est unique, signée et certifiée":
    "Every piece is unique, signed and certified",
  "© 2025 L'Épopée du Fil — Tous droits réservés":
    "© 2025 Cécile Hadjian — All rights reserved",

  // ----- Oeuvres page -----
  "Services": "Services",
  "Ce que je propose": "What I Offer",
  "Pour les créatifs, les professionnels de la création textile et de la haute couture.":
    "For creatives and professionals in textile design and haute couture.",
  "Échantillons et prototypes brodés": "Embroidered samples and prototypes",
  "Vous avez une idée, un dessin, une intention. Je la traduis en broderie avec une précision absolue — pour que vous puissiez valider votre vision avant de lancer une collection.":
    "You have an idea, a drawing, an intention. I translate it into embroidery with absolute precision, so you can validate your vision before launching a collection.",
  "Petites séries": "Small series",
  "De la pièce unique à la série limitée, je garantis une régularité et une qualité constante, quelle que soit la complexité du motif.":
    "From a single piece to a limited series, I guarantee consistent quality, however complex the motif.",
  "Conception de motifs sur-mesure": "Bespoke motif design",
  "Vous n'avez pas encore de dessin ? Je le crée. De l'esquisse à la numérisation, je conçois votre motif en tenant compte dès le départ de son rendu en broderie.":
    "Don't have a drawing yet? I create it. From sketch to digitising, I design your motif with its embroidered result in mind from the very start.",
  "Broderie sur matières difficiles": "Embroidery on difficult materials",
  "Velours, daim, organza, tulle, tissus techniques — je maîtrise le comportement de chaque support et adapte chaque paramètre machine en conséquence.":
    "Velvet, suede, organza, tulle, technical fabrics: I know how each one behaves and adjust every machine setting accordingly.",
  "Intégration de découpe laser": "Laser-cutting integration",
  "Pour des effets de relief, de transparence ou de volume impossibles à obtenir en broderie seule, j'intègre la découpe laser directement dans la conception de vos pièces.":
    "For effects of relief, transparency or volume that embroidery alone can't achieve, I build laser cutting directly into the design of your pieces.",

  "01 — Catégorie": "01 — Category",
  "02 — Catégorie": "02 — Category",
  "03 — Catégorie": "03 — Category",
  "04 — Catégorie": "04 — Category",
  "05 — Catégorie": "05 — Category",
  "06 — Catégorie": "06 — Category",

  "Art Textile, Les Tableaux brodés": "Textile Art: Embroidered Paintings",
  "C'est la broderie comme medium artistique à part entière.":
    "This is embroidery as an artistic medium in its own right.",
  "Mes œuvres encadrées sont conçues, dessinées et brodées comme des tableaux avec la même ambition qu'une peinture, mais réalisées entièrement en fils sur velours ou tissu précieux.":
    "My framed works are designed, drawn and embroidered like paintings, with all the ambition of a painting, but worked entirely in thread on velvet or fine fabric.",
  "Que cela soit des portraits mythologiques modernes, des figures d'ange ou des animaux fantastiques, chacune de mes œuvres est unique, fruit d'une recherche originale et d'une transcription minutieuse en dessin de broderie qui peut atteindre jusqu'à 1 million de points sur une seule œuvre.":
    "Whether modern mythological portraits, angelic figures or fantastical animals, each of my works is unique, born of original research and painstakingly translated into an embroidery design that can run to as many as a million stitches in a single piece.",

  "Costumes de Scène": "Stage Costumes",
  "La broderie de scène obéit à des lois propres.":
    "Stage embroidery plays by its own rules.",
  "Elle doit être spectaculaire vue de loin, irréprochable vue de près, et résister aux contraintes du mouvement et des projecteurs.":
    "It must be spectacular from a distance, flawless up close, and able to withstand the demands of movement and stage lighting.",
  "Je conçois et réalise des broderies pour des costumes de spectacle exigeants, en alliant volume, matières précieuses et techniques mixtes telles que broderie, appliqués, pierres serties, découpe laser.":
    "I design and create embroidery for demanding performance costumes, combining volume, precious materials and mixed techniques such as embroidery, appliqué, set stones and laser cutting.",
  "Réalisations pour court-métrage et spectacle de danse.":
    "Works created for a short film and a dance performance.",

  "Broderie sur Vêtements": "Embroidery on Garments",
  "De la veste souple au manteau épais, de la soie au daim, je brode sur tous les supports textiles avec la même exigence.":
    "From the supple jacket to the heavy coat, from silk to suede, I embroider on every kind of fabric with the same rigour.",
  "Chaque matière a son comportement propre sous l'aiguille que j'anticipe, j'apprivoise, et que j'utilise.":
    "Every material behaves in its own way under the needle — I anticipate it, tame it, and put it to work.",
  "Que cela soit des motifs photoréalistes, géométriques, floraux ou symboliques, je les conçois ou j'adapte votre dessin/idée pour qu'ils deviennent une broderie à la hauteur de votre création.":
    "Whether photo-realistic, geometric, floral or symbolic motifs, I design them or adapt your drawing/idea so they become embroidery worthy of your creation.",

  "Éléments Brodés à Appliquer": "Embroidered Appliqué Elements",
  "Ces pièces brodées sont conçues pour être appliquées sur un vêtement, un accessoire ou une décoration.":
    "These embroidered pieces are designed to be applied to a garment, an accessory or a decorative item.",
  "Que cela soit des feuilles dorées monumentales, des ailes en fil métallique, des créatures mythologiques ou des dentelles d'enlevage, je les réalise sur-mesure et je les brode sur des supports spéciaux qui permettent leur découpe/enlevage et leur application ultérieure.":
    "Whether monumental gilded leaves, metallic-thread wings, mythological creatures or cut-away lace, I make them bespoke and embroider them on special backings that allow their cutting/removal and subsequent application.",
  "C'est une solution idéale pour les créateurs qui souhaitent intégrer des motifs brodés complexes dans leurs collections sans contrainte de support.":
    "An ideal solution for designers who want to integrate complex embroidered motifs into their collections without backing constraints.",

  "Broderie sur Matières Délicates": "Embroidery on Delicate Materials",
  "L'organza, la mousseline de soie, le tulle sont souvent des matières ingrates pour la broderie machine car elles ne pardonnent aucune approximation dans le réglage de la tension, de la densité ou de la vitesse du fait de leur fragilité, leur finesse.":
    "Organza, silk chiffon and tulle are notoriously unforgiving for machine embroidery: their fragility and fineness leave no room for approximation in tension, density or speed settings.",
  "Je maîtrise la broderie sur ces supports fragiles depuis mes débuts, avec des motifs floraux complexes qui épousent la légèreté du tissu et ce, avec des fils parfois complexes.":
    "I have mastered embroidery on these fragile fabrics from the very start, with intricate floral motifs that follow the lightness of the cloth, using sometimes complex threads.",

  "Décoration Intérieure": "Interior Décor",
  "J'adore concevoir et réaliser des broderies monumentales conçues pour la décoration intérieure haut de gamme.":
    "I love designing and creating monumental embroideries made for high-end interiors.",
  "Ces pièces imposantes, comme cette chimère brodée sur velours rouge encadrée dans une structure bois laqué noir mat et or, illustrent la capacité à travailler à grande échelle avec la même exigence et détail qu'une broderie de petite taille sur vêtement.":
    "These imposing pieces, like this chimera embroidered on red velvet, set in a frame of matte-black lacquered wood and gold, show how I work on a grand scale with the same rigour and detail as a small embroidery on a garment.",
  "Elles sont conçues pour des intérieurs d'exception, des hôtels de luxe ou des collections privées. Elles jouent avec la lumière comme une tapisserie ne saurait faire.":
    "They are designed for exceptional interiors, luxury hotels and private collections. They play with light as no tapestry could.",

  "Vidéo Chimère de Sang (16/9)": "Chimère de Sang video (16/9)",
  "Placeholder Shopify — vignette à définir": "Shopify placeholder — thumbnail to define",
  "Vidéo à venir": "Video coming soon",

  // Modal labels
  "Fiche technique": "Technical sheet",
  "Dimensions": "Dimensions",
  "Temps de réalisation": "Production time",
  "Matériaux": "Materials",
  "Certificat d'authenticité inclus": "Certificate of authenticity included",
  "Demander un renseignement": "Request information",
  "Peinture de fil": "Thread painting",

  // ----- QuiSuisJe page -----
  "Le Parcours": "The Journey",
  "Du Dessin": "From Drawing",
  "à la Broderie": "to Embroidery",
  "La créativité d'une dessinatrice, la maîtrise technique d'une brodeuse, l'exigence d'une professionnelle :":
    "The creativity of a designer, the technical mastery of an embroiderer, the exacting standards of a professional:",
  "ces trois compétences sont fusionnées en un savoir-faire unique.":
    "these three skills are brought together in a single, distinctive craft.",

  "Les Racines": "The Roots",
  "Le dessin comme première langue": "Drawing as a first language",
  "Tout commence par une nécessité impérieuse : celle de dessiner. Cette passion du dessin ne m'a jamais quittée, il est aujourd'hui au cœur de chaque broderie que je conçois.":
    "It all starts with an overriding need: to draw. That passion for drawing has never left me, and it sits at the heart of every embroidery I design.",
  "Après un Baccalauréat Scientifique (car j'aime aussi les sciences), j'ai ensuite orienté mes études vers le Dessin et le Design Produit. J'y ai appris à structurer une composition, à maîtriser les outils de création informatique, et à penser une image pour qu'elle existe dans la matière, y compris en 3D et pas seulement sur papier.":
    "After a science baccalaureate (I love the sciences too), I went on to study Drawing and Product Design. I learned to structure a composition, master computer-aided creation tools, and think an image so that it exists in matter — including in 3D, not just on paper.",

  "L'Expertise Technique": "Technical Expertise",
  "La broderie mécanique et le textile": "Machine embroidery and textile",
  "C'est en intégrant une société de fabrication de jouets et de décoration haut de gamme que j'ai découvert la broderie mécanique. J'ai immédiatement su que j'avais trouvé mon médium de prédilection.":
    "I discovered machine embroidery when I joined a high-end toy and decoration manufacturer. I knew at once I had found my medium of choice.",
  "Pendant plus de 15 ans, j'ai perfectionné ma maîtrise des machines à broder et des logiciels de numérisation professionnels. J'ai appris ce qu'un tissu accepte ou refuse, ce que différents fils peuvent donner comme résultats étonnants ou désastreux… Cette connaissance de la matière est ce qui me permet aujourd'hui de réaliser ce que d'autres ne veulent pas fabriquer.":
    "For over 15 years I have refined my command of embroidery machines and professional digitising software. I have learned what a fabric will accept or refuse, what different threads can yield — stunning or disastrous. That hands-on knowledge of the material is what allows me, today, to make what others won't.",

  "L'Expérience du Terrain": "Hands-on Experience",
  "Les références professionnelles": "Professional references",
  "Mon parcours m'a conduite à travailler pour des clients aux exigences élevées. Pour Christine et Cécile Creactive, j'ai conçu et réalisé des broderies complexes sur des costumes de scène. Ces pièces devaient être non seulement spectaculaires sous les projecteurs mais aussi résister aux contraintes du mouvement.":
    "My path has led me to work for highly demanding clients. For Christine and Cécile Creactive, I designed and made complex embroideries on stage costumes — pieces that had to be spectacular under the spotlights and withstand the constraints of movement.",
  "Pour Mundia et Idyllis, j'ai créé des motifs brodés pour des jouets et des articles de décoration haut de gamme, sur des supports et des matières délicates telles que les différents types de soie. J'ai également réalisé les prototypes et le suivi de la fabrication à l'étranger.":
    "For Mundia and Idyllis, I created embroidered motifs for high-end toys and decorative items, on delicate materials such as various kinds of silk. I also produced the prototypes and oversaw manufacturing abroad.",
  "Ces expériences m'ont forgé une exigence simple : chaque pièce doit être belle, le plus parfaitement réalisée malgré les contraintes des matériaux et ce, quelle que soit sa complexité.":
    "These experiences left me with one simple standard: every piece must be beautiful and as perfectly made as possible despite the constraints of the materials, whatever its complexity.",

  "Aujourd'hui": "Today",
  "Je mets aujourd'hui ce savoir-faire au service des professionnels de la création textile, du design d'intérieur, et de la couture. Dessinatrice, infographiste et brodeuse, je suis votre interlocutrice unique, du brief au rendu final.":
    "Today I put this expertise to work for professionals in textile design, interior design and couture. As designer, graphic artist and embroiderer, I am your single point of contact, from brief to final result.",
  "Motifs complexes, matières délicates, effets impossibles : je conçois et réalise vos échantillons, prototypes et petites séries avec la même rigueur qu'une pièce unique.":
    "Complex motifs, delicate materials, \"impossible\" effects: I design and produce your samples, prototypes and small series with the same rigour as a one-off piece.",

  "« Dessinatrice et infographiste de formation, brodeuse de métier, perfectionniste par nature. Ce que je fais, je le fais avec créativité, précision, rigueur et passion ! »":
    "\"Trained as a designer and graphic artist, an embroiderer by profession, a perfectionist by nature. What I do, I do with creativity, precision, rigour and passion!\"",
  "Cécile Hadjian": "Cécile Hadjian",

  // ----- SavoirFairePage -----
  "Nul algorithme ne crée ces œuvres.": "No algorithm creates these works.",
  "Chaque tapisserie naît d'un processus artisanal en trois étapes, où la main de l'artiste guide chaque décision.":
    "Every tapestry is born of a three-stage controlled process where the artist's hand guides every decision.",
  "Le Dessin à la Main": "Drawing by Hand",
  "L'Imagination prend forme": "Imagination takes shape",
  "Tout commence par un dessin à la main, fruit de mon imaginaire. Je puise dans les civilisations disparues, les bestiaires médiévaux et la Renaissance pour esquisser des chimères modernes. Ce premier geste, intime et spontané, pose les fondations de l'œuvre finale.":
    "It all begins with a hand drawing, born of my imagination. I draw on lost civilisations, medieval bestiaries and the Renaissance to sketch modern chimeras. This first gesture, intimate and spontaneous, lays the foundations of the final work.",
  "La Transcription Point par Point": "Stitch-by-Stitch Transcription",
  "Guider la lumière": "Guiding the light",
  "Le dessin est ensuite recréé point par point sur ordinateur — pas scanné, mais redessiné méticuleusement. C'est à cette étape cruciale que je décide du sens de chaque fil pour guider la lumière. Plus de 90 couleurs sont sélectionnées, chaque fil ayant des propriétés différentes : mat, brillant ou métallisé.":
    "The drawing is then recreated stitch by stitch on computer — not scanned, but meticulously redrawn. At this crucial stage I decide the direction of every thread to guide the light. More than 90 colours are selected, each thread with different properties: matte, glossy or metallic.",
  "La Réalisation sur Machine": "Production on the Machine",
  "Précision d'orfèvre": "A goldsmith's precision",
  "La réalisation sur la brodeuse exige une surveillance constante et une précision d'orfèvre. Chaque pièce nécessite entre 50 et 100 heures de travail. J'incruste du liège et des tissus texturés, rebrodés pour créer un relief 3D saisissant. C'est un processus lent qui transforme le fil en tapisserie contemporaine.":
    "Production on the embroidery machine demands constant supervision and a goldsmith's precision. Each piece takes between 50 and 100 hours of work. I inlay cork and textured fabrics, re-embroidered to create a striking 3D relief. It is a slow process that turns thread into contemporary tapestry.",
  "« Je ne remplis pas, je sculpte. Chaque fil a une direction, un sens, une intention. C'est cette précision qui donne vie à la matière. »":
    "\"I don't fill in, I sculpt. Every thread has a direction, a meaning, an intention. That precision is what brings the material to life.\"",

  // ----- Matieres page -----
  "Des Fils Sourcés": "Threads Sourced",
  "pour Votre Exigence": "Across the World",
  "En haute couture, le choix du fil n'est pas un détail, c'est une décision technique. Je sélectionne chaque matière en fonction de votre tissu, de votre motif et du rendu final attendu. Rien n'est laissé au hasard.":
    "In haute couture, the choice of thread is not a detail — it is a technical decision. I select each material based on your fabric, your motif and the desired final result. Nothing is left to chance.",
  "Pour garantir un rendu digne des plus grandes maisons, je source et je travaille avec des fils sélectionnés auprès des meilleurs fournisseurs mondiaux, chacun choisi pour ses propriétés spécifiques de rendu satiné ou pas, de tenue et de texture.":
    "To guarantee a result worthy of the greatest houses, I source and work with threads selected from the best suppliers worldwide, each chosen for its specific properties of sheen, hold and texture.",
  "Japon": "Japan",
  "Allemagne": "Germany",
  "Italie": "Italy",
  "Fils métalliques": "Metallic threads",
  "Viscose": "Viscose",
  "Coton": "Cotton",
  "Pour les motifs qui doivent briller, accrocher la lumière et résister dans le temps tout en gardant de la souplesse.":
    "For motifs that need to shine, catch the light and stand the test of time while remaining supple.",
  "Pour la douceur du rendu, l'intensité et le satiné des couleurs et la fluidité des dégradés.":
    "For softness of finish, intensity and satin sheen of colour, and fluid gradients.",
  "Pour les broderies qui exigent tenue, précision et noblesse dans les finitions tout en gardant un aspect naturel mat avec des couleurs toute en douceur.":
    "For embroideries that demand hold, precision and refined finishes while keeping a natural matte feel with gentle colours.",
  "Broder avec": "Embroider with",
  "créativité": "creativity",
  "et": "and",
  "intelligence": "intelligence",
  "Je gère plus de 500 couleurs de fils aux propriétés différentes, mats, brillants, métallisés, fins, épais, ce qui me permet de choisir ceux qui vont capter et réfléchir la lumière naturelle. Votre pièce change d'aspect selon l'éclairage : elle vit, elle vibre, elle surprend.":
    "I work with over 500 thread colours with different properties — matte, glossy, metallic, fine, thick — which lets me pick those that will catch and reflect natural light. Your piece changes appearance depending on the lighting: it lives, vibrates, surprises.",
  "Je ne remplis pas, je construis, souvent couches par couches. En variant les techniques de points et les épaisseurs de fil, je recrée le grain d'une peau, la froideur d'un métal, la fibre d'un végétal. Ce sont les effets de relief qui donnent à votre broderie une dimension sculpturale unique.":
    "I don't fill in, I build — often layer by layer. By varying stitch techniques and thread thicknesses, I recreate the grain of skin, the coolness of metal, the fibre of a plant. These relief effects give your embroidery a unique sculptural dimension.",
  "L'Architecture du Fil": "The Architecture of Thread",
  "Chaque fil a une direction choisie avec intention. C'est cette orientation précise qui crée la profondeur, le mouvement et la cohérence visuelle de l'ensemble. Une broderie bien construite se lit comme un dessin, parce qu'elle en est un, mais avec une dimension supplémentaire irremplaçable.":
    "Every thread has a direction chosen with intent. It is this precise orientation that creates depth, movement and visual coherence. A well-built embroidery reads like a drawing — because it is one — but with an irreplaceable extra dimension.",
  "Ce que cela change pour vous": "Why it matters for you",
  "Le choix des matières n'est pas qu'une question esthétique. C'est ce qui détermine la tenue de votre broderie dans le temps, sa compatibilité avec votre tissu, et la conformité du rendu avec votre brief.":
    "The choice of materials is not only an aesthetic question. It governs how your embroidery wears over time, how well it sits with your chosen fabric, and how closely the finished piece answers your brief.",
  "En travaillant avec moi, vous bénéficiez de 15 ans de connaissance terrain sur les fils et les supports :":
    "Working with me means drawing on 15 years of hands-on knowledge of threads and backings:",
  "c'est cette expertise qui vous évite les erreurs coûteuses ou les déceptions, et vous garantit un résultat conforme dès la première réalisation.":
    "the kind of expertise that saves you costly missteps and disappointments, and delivers a piece that's right the first time.",

  // ----- Contact page -----
  "Parlons de votre projet": "Let's talk about your project",
  "Échangeons": "Get in Touch",
  "Vous avez un motif à réaliser, un tissu particulier, une contrainte technique à résoudre ?":
    "Do you have a motif to produce, a particular fabric, a technical constraint to solve?",
  "Décrivez-moi votre projet afin que je vous réponde au plus vite.":
    "Tell me about your project and I'll get back to you as soon as possible.",
  "Brodeuse": "Artist",
  "Email": "Email",
  "Atelier": "Studio",
  "Joinville le pont, France": "Joinville-le-Pont, France",
  "Nom": "Name",
  "Sujet": "Subject",
  "Message": "Message",
  "Votre nom": "Your name",
  "Choisir un sujet": "Choose a subject",
  "Échantillon / Prototype": "Sample / Prototype",
  "Petite série": "Small series",
  "Conception de motif sur mesure": "Bespoke motif design",
  "Broderie sur matière délicate": "Embroidery on delicate material",
  "Autre demande": "Other request",
  "Décrivez votre projet : type de pièce, matière, motif souhaité, délai...":
    "Describe your project: type of piece, material, desired motif, deadline…",
  "Envoyer": "Send",
  "J'ai travaillé et je travaille avec des sociétés de décoration, d'art du spectacle, des créateurs couture indépendants et des ateliers en France et à l'international. Toutes les demandes sont traitées avec discrétion.":
    "I have worked and continue to work with decoration companies, performing-arts production houses, independent couture designers and ateliers in France and internationally. All enquiries are handled with discretion.",
  "Message envoyé": "Message sent",
  "Merci pour votre message. Je vous répondrai dans les plus brefs délais.":
    "Thank you for your message. I will get back to you as soon as possible.",
  "Envoyer un autre message": "Send another message",
  "Fermer": "Close",

  // Image alt text — Index page
  "Broderie mécanique d'art en fils d'or sur liège":
    "High-end digital embroidery in gold thread on cork",
  "Détail macro de broderie d'art montrant la texture des fils":
    "Macro detail of art embroidery showing the texture of the threads",
  "Matières premières de luxe pour la broderie d'art":
    "Luxury raw materials for art embroidery",
  "Fils de coton et métalliques en gros plan":
    "Cotton and metallic threads in close-up",
  "Cécile Hadjian — artiste brodeuse, designer et historienne":
    "Cécile Hadjian — embroidery artist, designer and historian",
  "Portrait de Cécile Hadjian, dessinatrice et brodeuse":
    "Portrait of Cécile Hadjian, designer and embroiderer",
  "Cécile Hadjian avec son tableau Aphrodite en Gloire":
    "Cécile Hadjian with her work Aphrodite in Glory",
  "Cécile Hadjian — Artiste textile":
    "Cécile Hadjian — Textile artist",
  "Détail de la crinière brodée de la Chimère Or":
    "Detail of the embroidered mane of the Golden Chimera",
  "Détail des écailles brodées de la Chimère Or":
    "Detail of the embroidered scales of the Golden Chimera",

  // ----- Fragments inter-<em> (Inspiration / SavoirFaire / ValueProposition) -----
  "Mon travail puise dans la grandeur des civilisations disparues — de":
    "My work draws on the grandeur of lost civilisations — from",
  "à l'": "to",
  "Égypte Antique": "Ancient Egypt",
  ". Ma formation d'illustratrice se combine à une maîtrise experte de la":
    ". My training as an illustrator combines with expert command of",
  "Je revisite les bestiaires médiévaux, les légendes nordiques et la finesse de la Renaissance italienne pour créer des":
    "I revisit medieval bestiaries, Nordic legends and the finesse of the Italian Renaissance to create",
  "chimères modernes": "modern chimeras",
  ". Chaque tableau raconte une histoire ancienne, réécrite avec un langage contemporain.":
    ". Each piece tells an ancient story, rewritten in a contemporary language.",
  "Plus qu'une broderie, c'est une": "More than embroidery, it is a",
  "pour repousser les limites de la matière.":
    "to push the limits of the material.",
  "et une": "and a",
  "Tout commence par un dessin à la main, fruit de mon imaginaire.":
    "It all begins with a hand drawing, born of my imagination.",
  "Ce dessin est ensuite recréé, non pas par un scanner, mais":
    "This drawing is then recreated, not by a scanner, but",
  "redessiné point par point": "redrawn stitch by stitch",
  "sur ordinateur. C'est à cette étape que je décide du sens de chaque fil pour guider la lumière.":
    "on computer. It is at this stage that I decide the direction of every thread to guide the light.",
  "Enfin, la réalisation sur machine à broder exige une":
    "Finally, production on the embroidery machine demands",
  "précision d'orfèvre": "goldsmith's precision",
  ". C'est un processus lent, exigeant, qui transforme le fil en":
    ". It is a slow, demanding process that turns thread into",

  // ----- Concatenated variants (DOM merges multi-line JSX strings) -----
  "La créativité d'une dessinatrice, la maîtrise technique d'une brodeuse, l'exigence d'une professionnelle : ces trois compétences sont fusionnées en un savoir-faire unique.":
    "The creativity of a designer, the technical mastery of an embroiderer, the exacting standards of a professional: these three skills are brought together in a single, distinctive craft.",
  "Vous avez un motif à réaliser, un tissu particulier, une contrainte technique à résoudre ? Décrivez-moi votre projet afin que je vous réponde au plus vite.":
    "Do you have a motif to produce, a particular fabric, a technical constraint to solve? Tell me about your project and I'll get back to you as soon as possible.",
  "En travaillant avec moi, vous bénéficiez de 15 ans de connaissance terrain sur les fils et les supports : c'est cette expertise qui vous évite les erreurs coûteuses ou les déceptions, et vous garantit un résultat conforme dès la première réalisation.":
    "Working with me means drawing on 15 years of hands-on knowledge of threads and backings: the kind of expertise that saves you costly missteps and disappointments, and delivers a piece that's right the first time.",

  // ----- Oeuvres ALT texts -----
  "Chimère d'Or — non encadrée": "Golden Chimera — unframed",
  "Chimère de Sang — cadre en atelier": "Chimère de Sang — frame in the studio",
  "Chimère de Sang — œuvre entière encadrée": "Chimère de Sang — full framed work",
  "Costume Iris — broderie de scène": "Iris Costume — stage embroidery",
  "Costume Rose — broderie de scène": "Rose Costume — stage embroidery",
  "Détail aile pour dos": "Wing detail for the back",
  "Détail du costume Rose": "Detail of the Rose costume",
  "Détail haut du costume Iris": "Top detail of the Iris costume",
  "Détail sphinx pour caraco": "Sphinx detail for camisole",
  "Feuilles dorées monumentales": "Monumental gilded leaves",
  "Foulard soie dégradé pivoines": "Silk scarf, peony gradient",
  "Manteau aile argentée sur laine noire": "Coat with silver wing on black wool",
  "Phœnix argenté sur laine cachemire noir": "Silver phoenix on black cashmere wool",
  "Tulle écume": "Foam tulle",
  "Vignette vidéo — Chimère de Sang": "Video thumbnail — Chimère de Sang",

  // ----- Artwork data (Oeuvres modals & cards) -----
  "255 heures": "255 hours",
  "260 heures": "260 hours",
  "280 heures": "280 hours",
  "295 heures": "295 hours",
  "300 heures": "300 hours",
  "320 heures": "320 hours",
  "Fils métalliques japonais, viscose, coton":
    "Japanese metallic threads, viscose, cotton",
  "Fils métalliques japonais, viscose, coton, fond velours or":
    "Japanese metallic threads, viscose, cotton on gold velvet ground",
  "Fils métalliques japonais, viscose, coton, velours pourpre":
    "Japanese metallic threads, viscose, cotton on purple velvet",

  // ----- Artwork descriptions (Oeuvres modals) -----
  "Inspirée de l'Art Nouveau et de la beauté intemporelle de Vénus, cette œuvre mêle plus de 90 couleurs de fils pour sculpter un portrait vibrant. Chaque mèche de cheveux, chaque reflet de bijou est brodé point par point, créant un jeu de textures et de lumières saisissant.":
    "Inspired by Art Nouveau and the timeless beauty of Venus, this piece blends more than 90 thread colours to sculpt a vibrant portrait. Every strand of hair and every glint of jewellery is embroidered stitch by stitch, creating a striking interplay of textures and light.",
  "Inspirée de l'iconographie de l'archange Saint Michel terrassant le dragon, cette œuvre monumentale mêle broderie dense et dessin au fil libre. Les ailes aux dégradés de bleus, les flammes en fil rouge et la patine dorée du fond créent une composition vibrante entre art sacré et tapisserie contemporaine.":
    "Inspired by the iconography of the Archangel Saint Michael slaying the dragon, this monumental work combines dense embroidery with free-motion thread drawing. Wings in graduated blues, flames in red thread and the gilded patina of the background compose a vibrant work poised between sacred art and contemporary tapestry.",
  "Portrait textile inspiré des maîtres préraphaélites, Magdalène déploie un travail minutieux sur les carnations, les drapés et les ornements floraux. Les contrastes entre verts profonds, ors et rouges incarnent une présence à la fois douce et souveraine.":
    "A textile portrait inspired by the Pre-Raphaelite masters, Magdalène unfolds a painstaking treatment of flesh tones, drapery and floral ornament. Contrasts between deep greens, golds and reds embody a presence at once gentle and sovereign.",
  "Hommage à la déesse mésopotamienne de l'amour et de la guerre, cette œuvre puise dans l'iconographie antique et l'esthétique Art Nouveau. Les teintes profondes de pourpre, de bleu glacial et de rubis créent un portrait envoûtant où chaque bijou et chaque mèche de cheveux vibre d'une intensité surnaturelle.":
    "A tribute to the Mesopotamian goddess of love and war, this work draws on ancient iconography and Art Nouveau aesthetics. Deep purples, icy blues and ruby tones create a spellbinding portrait in which every jewel and every strand of hair pulses with an otherworldly intensity.",
  "Variation solaire de la chimère médiévale, cette pièce oppose la puissance minérale de la bête à un fond doré lumineux brodé de motifs architecturaux. Les rehauts bordeaux et argentés accentuent le relief de la gueule, des ailes et des ornements, dans un dialogue entre bestiaire gothique et faste décoratif.":
    "A solar variation on the medieval chimera, this piece sets the stony power of the beast against a luminous gold ground embroidered with architectural motifs. Burgundy and silver highlights accentuate the relief of the jaws, wings and ornaments in a dialogue between gothic bestiary and decorative splendour.",
  "Inspirée des vitraux et de l'iconographie Art Nouveau, cette Aphrodite réinterprète la déesse dans une palette de bleus profonds, carmins et ors. Le travail des carnations, des drapés et du fond ornemental compose un portrait textile à la fois lumineux, sensuel et solennel.":
    "Inspired by stained glass and Art Nouveau iconography, this Aphrodite reinterprets the goddess in a palette of deep blues, carmines and golds. The work on flesh tones, drapery and ornamental background composes a textile portrait that is at once luminous, sensual and solemn.",

  // ----- Shopify-specific strings (extracted from theme) -----
  "broderie machine haut de gamme":
    "High end machine embroidery",
  "Là où l'art du dessin rencontre l'exigence de la haute couture. Chaque création est une broderie de précision, que je conçois et réalise pour les professionnels qui refusent le compromis.":
    "Where the art of design meets the exacting standards of haute couture. Each creation is a precision embroidery, designed and produced for professionals who refuse to compromise.",
  "VOTRE VISION":
    "YOUR VISION",
  "Une Expertise Rare":
    "A Rare Expertise",
  "au Service de Votre Création":
    "Devoted to Your Creation",
  "Je comprends votre langage créatif parce que je suis d'abord dessinatrice. Vos motifs les plus complexes, vos tissus les plus délicats, vos exigences les plus élevées je les traduis en broderies d'exception.":
    "I understand your creative language because I am first and foremost a designer. Your most complex motifs, your most delicate fabrics, your highest demands — I translate them into exceptional embroideries.",
  "Du premier brief au rendu final, vous n'avez qu'une seule interlocutrice. Pas de perte d'information. Pas de compromis sur votre vision.":
    "From the first brief to the final result, you have a single point of contact. No loss of information. No compromise on your vision.",
  "Concevoir avec le Fil :":
    "Designing with Thread:",
  "Une Maîtrise Complète":
    "A Complete Mastery",
  "Ma formation d'illustratrice et d'infographiste combinée à 15 ans de maîtrise des machines industrielles et des logiciels graphiques et de broderie me permettent de réaliser ce que d'autres ne peuvent pas. Velours, organza, faux daim, soie, tulle, chaque matière a ses difficultés. Je les connais car je les ai expérimentées.":
    "My training as an illustrator and graphic designer, combined with 15 years of mastery of industrial machines and graphic and embroidery software, lets me achieve what others cannot. Velvet, organza, faux suede, silk, tulle — each material has its challenges. I know them because I've worked with them.",
  "heures de travail par projet":
    "hours of work per project",
  "Chaque projet est traité avec la même exigence, qu'il s'agisse d'un échantillon unique ou d'une petite série. Parfois plus de 90 couleurs de fils seront nécessaires ou parfois juste 2, tout dépendra de la numérisation toujours sur-mesure, avec à la clef un rendu le plus irréprochable possible, à chaque fois.":
    "Every project is treated with the same rigour, whether a one-off sample or a small series. Sometimes more than 90 thread colours are required, sometimes just two — it all depends on the always-bespoke digitising, delivering the most flawless possible result every time.",
  "Pour obtenir un rendu digne de la haute couture, je sélectionne des fils sourcés mondialement : l'éclat des fils métalliques japonais, le soyeux de la viscose allemande, la noblesse du coton italien. Chaque fil est choisi pour ce qu'il apportera à votre matière et à votre motif.":
    "To achieve a result worthy of haute couture, I select threads sourced worldwide: the brilliance of Japanese metallic threads, the silkiness of German viscose, the nobility of Italian cotton. Each thread is chosen for what it will bring to your fabric and your motif.",
  "Grâce à plus de 90 couleurs et à des fils aux propriétés différentes, mats, brillants, métallisés, la broderie captera et jouera avec la lumière naturelle. Votre pièce changera et vibrera selon l'heure et l'éclairage.":
    "With over 90 colours and threads of different properties — matte, glossy, metallic — the embroidery captures and plays with natural light. Your piece shifts and vibrates with the hour and the lighting.",
  "Du Dessin à la Broderie :":
    "From Drawing to Embroidery:",
  "Zéro Approximation":
    "Zero Approximation",
  "Tout commence par le dessin. Votre motif est conçu ou adapté avec un regard de dessinatrice et d'infographiste professionnelle, chaque forme est pensée pour exister en broderie et pas seulement sur papier.":
    "Everything begins with the drawing. Your motif is designed or adapted with the eye of a professional illustrator and graphic designer — every shape conceived to exist in embroidery, not only on paper.",
  "Ce dessin est ensuite numérisé point par point dans les logiciels dédiés à la broderie. C'est à cette étape que je décide du sens de chaque fil, de la densité de chaque zone, afin d'adapter le dessin au tissu, lui donner ses aspects soyeux, mat ou même rugueux, et garantir la précision du rendu.":
    "The drawing is then digitised stitch by stitch in dedicated embroidery software. At this stage I decide the direction of each thread and the density of each zone, adapting the design to the fabric, giving it a silky, matte or even rough finish, and guaranteeing the precision of the result.",
  "Enfin, la réalisation sur machine professionnelle exige une surveillance constante et une grande précision. Un processus exigeant, maîtrisé de bout en bout, qui transforme votre vision en matière vivante.":
    "Finally, production on a professional machine demands constant supervision and great precision. A rigorous process, mastered end-to-end, that turns your vision into living matter.",
  "Vénus":
    "Venus",
  "Œuvre Unique, brodée et encadré sous verre qualité musée":
    "Unique work, embroidered and framed under museum-quality glass",
  "73 x 55 x 2,5 cm":
    "73 x 55 x 2.5 cm",
  "95 heures":
    "95 hours",
  "Broderie en fils viscose et coton sur panne de velours":
    "Embroidery in viscose and cotton threads on velvet panne",
  "Saint Michel":
    "Saint Michael",
  "141 x 94 x 1,5 cm":
    "141 x 94 x 1.5 cm",
  "160 heures":
    "160 hours",
  "Inspirée de la fontaine Saint Michel à Paris":
    "Inspired by the Saint-Michel fountain in Paris",
  "Magdalène":
    "Magdalene",
  "79 x 60 x 5 cm":
    "79 x 60 x 5 cm",
  "102 heures":
    "102 hours",
  "Inspirée de l'oeuvre du peintre italien de la Renaissance Carlo Crivelli":
    "Inspired by the work of the Italian Renaissance painter Carlo Crivelli",
  "Ishtar":
    "Ishtar",
  "75 x 55 x 5 cm":
    "75 x 55 x 5 cm",
  "97 heures":
    "97 hours",
  "Chimère d'Or":
    "Golden Chimera",
  "92 x 82 x 1,5 cm":
    "92 x 82 x 1.5 cm",
  "83 heures":
    "83 hours",
  "Aphrodite":
    "Aphrodite",
  "71 x 52 x 5 cm  Réalisation":
    "71 x 52 x 5 cm  Production",
  "90 heures":
    "90 hours",
  "Pour les créatifs, les professionnels de la création textile et de la haute couture":
    "For creatives and professionals in textile design and haute couture",
  "demande de prix":
    "request a quote",
  "Demande de prix":
    "Request a quote",
  "Demande de prix →":
    "Request a quote →",
  "DEMANDE DE PRIX":
    "REQUEST A QUOTE",
  "Laurent Cazot Photography":
    "Laurent Cazot Photography",
  "Studio Cadres":
    "Studio Cadres",
  "Le trait comme première langue":
    "The line as a first language",
  "L'industrie du Jouet et du Textile":
    "The Toy and Textile Industry",
  "L'Âme de l'Œuvre":
    "The Soul of the Work",
  "L'Historienne et l'Érudite":
    "The Historian and the Scholar",
  "La Synthèse":
    "The Synthesis",
  "à l'Histoire":
    "to History",
  "Votre motif prend forme":
    "Your motif takes shape",
  "La Conception du Dessin":
    "Designing the Drawing",
  "Tout commence par le dessin, l'idée, le croquis. Votre motif est conçu de toutes pièces ou adapté à partir de vos éléments existants avec mon regard de dessinatrice professionnelle et mon analyse de brodeuse.":
    "It all begins with the drawing, the idea, the sketch. Your motif is created from scratch or adapted from your existing elements with my eye as a professional designer and my analysis as an embroiderer.",
  "C'est cette double compétence, artiste et technicienne, qui garantit que votre vision reste intacte du brief jusqu'au rendu final. Vos créations gagnent en raffinement, en exclusivité et en valeur perçue auprès de vos clients.":
    "This dual skill — artist and technician — is what guarantees your vision stays intact from brief to final result. Your creations gain in refinement, exclusivity and perceived value with your clients.",
  "La précision point par point":
    "Precision stitch by stitch",
  "La Numérisation sur Mesure":
    "Bespoke Digitising",
  "Je refais le dessin entièrement dans des logiciels professionnels dédiés à la broderie, point par point. C'est à cette étape que je décide du sens de chaque fil, de la densité de chaque zone, des propriétés de chaque couleur : mat, brillant ou métallisé, le tout en fonction du tissu utilisé.":
    "I redraw the design entirely in professional embroidery software, stitch by stitch. At this stage I decide the direction of each thread, the density of each zone, and the properties of each colour — matte, glossy or metallic — all according to the fabric used.",
  "Cette étape souvent longue, est pourtant décisive. Elle anticipe les contraintes de votre tissu, élimine au maximum les erreurs avant même que la machine ne commence, et garantit un rendu reproductible à l'identique, que cela soit pour vos échantillons ou vos séries.":
    "This step is often long, yet decisive. It anticipates the constraints of your fabric, eliminates as many errors as possible before the machine even starts, and guarantees a result that can be reproduced identically, whether for your samples or your series.",
  "La réalisation sur machine industrielle exige une surveillance constante et une connaissance précise des paramètres de broderie tels que : tension, vitesse, densité, le tout adapté à chaque matière. Velours de coton, de viscose ou de soie, organza, faux daim, mousseline de soie : je connais le comportement des tissus et de leurs supports et j'anticipe donc ses réactions.":
    "Production on an industrial machine demands constant supervision and precise knowledge of embroidery parameters — tension, speed, density — all adapted to each material. Cotton, viscose or silk velvet, organza, faux suede, silk chiffon: I know how these fabrics and their backings behave, and I anticipate their reactions.",
  "15 ans d'expérience, c'est aussi savoir travailler vite, mais en prenant le temps pour éviter les erreurs, et avec rigueur. Vous respectez vos échéances, vous sécurisez vos lancements, et vous recevez des pièces conformes sans allers-retours inutiles.":
    "15 years of experience also means knowing how to work fast — but taking the time to avoid mistakes, and with rigour. You meet your deadlines, secure your launches, and receive compliant pieces without unnecessary back-and-forth.",
  "Une interlocutrice unique":
    "A single point of contact",
  "Du dessin au fil brodé, vous n'avez qu'un seul contact. Votre vision ne se perd pas dans une chaîne de prestataires.":
    "From drawing to embroidered thread, you have a single contact. Your vision is not lost in a chain of providers.",
  "Zéro compromis sur la qualité":
    "Zero compromise on quality",
  "Exigence sur les finitions, maîtrise des matières, respect des standards du luxe : chaque pièce sera conforme à ce que vous attendez, dans le respect des contraintes des matériaux.":
    "Exacting standards on finishes, mastery of materials, respect for luxury standards: every piece will meet your expectations, within the constraints of the materials.",
  "Adaptable à tous vos supports":
    "Adaptable to every support",
  "Velours, daim, organza, soie, tulle, tissus techniques : vous concrétisez des projets variés sans multiplier les prestataires.":
    "Velvet, suede, organza, silk, tulle, technical fabrics: you realise varied projects without multiplying providers.",
  "Réactivité et fiabilité":
    "Responsiveness and reliability",
  "Basée en France, disponible rapidement, discrète par nature. Votre identité de création reste protégée.":
    "Based in France, quickly available, discreet by nature. Your creative identity stays protected.",
  "Un partenariat sans compromis":
    "A partnership without compromise",
  "« Je ne numérise pas, je traduis. Chaque fil a une direction, un poids, une intention, pensés pour que votre vision existe exactement comme vous l'avez imaginée. »":
    "\"I don't digitise, I translate. Every thread has a direction, a weight, an intention, conceived so that your vision exists exactly as you imagined it.\"",
  "Éclat & précision":
    "Brilliance & precision",
  "Soyeux & lumineux":
    "Silky & luminous",
  "Noblesse & résistance":
    "Nobility & strength",
  "Chaque fil a un sens, une direction choisie avec intention. C'est cette orientation précise qui crée l'effet de profondeur et de mouvement, transformant une surface plane en une véritable sculpture textile.":
    "Every thread has a meaning, a direction chosen with intent. This precise orientation creates the effect of depth and movement, turning a flat surface into a true textile sculpture.",
  "Matières Épopée":
    "Materials",
  "Pour obtenir une profondeur inégalée, je compose avec des fils sourcés mondialement, sélectionnés pour leurs propriétés uniques de lumière et de texture.":
    "To achieve unmatched depth, I work with threads sourced worldwide, selected for their unique properties of light and texture.",
  "Des fils sourcés à travers le monde":
    "Threads sourced from around the world",
  "Peindre avec le Fil":
    "Painting with Thread",
  "Contact Épopée":
    "Contact",
  "PARLONS DE VOTRE PROJET":
    "LET'S TALK ABOUT YOUR PROJECT",
  "Artiste":
    "Artist",
  "cecile@cecilehadjian.fr":
    "cecile@cecilehadjian.fr",

  // ----- Additional Shopify strings -----
  "Chaque projet naît d'un processus maîtrisé en trois étapes, où la précision du dessin, l'expertise du logiciel et la rigueur de la machine se combinent pour un résultat irréprochable. Une seule interlocutrice. Zéro approximation.":
    "Every project begins with a mastered three-step process, where the precision of the drawing, the expertise of the software and the rigour of the machine combine for a flawless result. A single point of contact. Zero approximation.",
  "Broderie machine haut de gamme":
    "High end machine embroidery",
  "Vous avez un projet ? Parlons-en.":
    "Do you have a project? Let's talk.",
  "Échantillons · Prototypes · Petites séries":
    "Samples · Prototypes · Small series",
  "Tous droits réservés":
    "All rights reserved",
  "Chaque projet naît d'un processus maîtrisé en trois étapes, où la précision du dessin, l'expertise du logiciel et la rigueur de la machine se combinent pour un résultat irréprochable.":
    "Every project begins with a mastered three-step process, where the precision of the drawing, the expertise of the software and the rigour of the machine combine for a flawless result.",
  "Une seule interlocutrice. Zéro approximation.":
    "A single point of contact. Zero approximation.",
  "© 2026 Cécile Hadjian — Tous droits réservés":
    "© 2026 Cécile Hadjian — All rights reserved",
  "© 2025 Cécile Hadjian — Tous droits réservés":
    "© 2025 Cécile Hadjian — All rights reserved",
  "© 2026 L'Épopée du Fil — Tous droits réservés":
    "© 2026 Cécile Hadjian — All rights reserved",
};

  var ATTRS = ["alt", "placeholder", "title", "aria-label"];
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, CODE: 1, PRE: 1 };
  var SKIP_ATTR = "data-i18n-skip";
  var STORAGE_KEY = "ch_lang";

  function normalize(s) {
    return s.replace(/[\u2019\u02BC]/g, "'").replace(/\s+/g, " ").trim();
  }

  var LOOKUP = Object.create(null);
  for (var fr in TRANSLATIONS) {
    if (Object.prototype.hasOwnProperty.call(TRANSLATIONS, fr)) {
      LOOKUP[normalize(fr)] = TRANSLATIONS[fr];
    }
  }

  var originalText = new WeakMap();
  var originalAttrs = new WeakMap();

  function shouldSkip(node) {
    var el = node;
    while (el) {
      if (el.nodeType === 1) {
        if (SKIP_TAGS[el.tagName]) return true;
        if (el.hasAttribute && el.hasAttribute(SKIP_ATTR)) return true;
      }
      el = el.parentNode;
    }
    return false;
  }

  function translateTextNode(node, toEN) {
    if (shouldSkip(node)) return;
    if (toEN) {
      var current = node.nodeValue || "";
      if (!current.trim()) return;
      if (originalText.has(node)) return;
      var en = LOOKUP[normalize(current)];
      if (en !== undefined) {
        originalText.set(node, current);
        var lead = (current.match(/^\s*/) || [""])[0];
        var trail = (current.match(/\s*$/) || [""])[0];
        node.nodeValue = lead + en + trail;
      }
    } else {
      var orig = originalText.get(node);
      if (orig !== undefined) {
        node.nodeValue = orig;
        originalText.delete(node);
      }
    }
  }

  function translateAttrs(el, toEN) {
    if (shouldSkip(el)) return;
    for (var i = 0; i < ATTRS.length; i++) {
      var attr = ATTRS[i];
      var current = el.getAttribute(attr);
      if (current === null) continue;
      if (toEN) {
        var en = LOOKUP[normalize(current)];
        if (en !== undefined) {
          var mem = originalAttrs.get(el);
          if (!mem) { mem = new Map(); originalAttrs.set(el, mem); }
          if (!mem.has(attr)) mem.set(attr, current);
          el.setAttribute(attr, en);
        }
      } else {
        var mem2 = originalAttrs.get(el);
        var orig2 = mem2 && mem2.get(attr);
        if (orig2 !== undefined) {
          el.setAttribute(attr, orig2);
          mem2.delete(attr);
        }
      }
    }
  }

  function walk(root, toEN) {
    if (!root || shouldSkip(root)) return;
    if (root.nodeType === 3) { translateTextNode(root, toEN); return; }
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.nodeType === 1) translateAttrs(root, toEN);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, null);
    var n = walker.nextNode();
    while (n) {
      if (n.nodeType === 1) {
        if (SKIP_TAGS[n.tagName] || n.hasAttribute(SKIP_ATTR)) {
          n = walker.nextSibling() || walker.nextNode();
          continue;
        }
        translateAttrs(n, toEN);
      } else if (n.nodeType === 3) {
        translateTextNode(n, toEN);
      }
      n = walker.nextNode();
    }
  }

  var observer = null;
  var active = false;

  function applyLanguage(lang) {
    var toEN = lang === "en";
    walk(document.body, toEN);
    document.documentElement.lang = toEN ? "en" : "fr";

    if (toEN && !active) {
      active = true;
      observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === "childList") {
            m.addedNodes.forEach(function (n) { walk(n, true); });
          } else if (m.type === "characterData" && m.target.nodeType === 3) {
            if (!originalText.has(m.target)) translateTextNode(m.target, true);
          } else if (m.type === "attributes" && m.target.nodeType === 1) {
            translateAttrs(m.target, true);
          }
        }
      });
      observer.observe(document.body, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ATTRS,
      });
    } else if (!toEN && active) {
      if (observer) observer.disconnect();
      observer = null;
      active = false;
    }
  }

  function buildToggle(initial) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "epopee-js-lang-btn";
    btn.setAttribute(SKIP_ATTR, "true");
    btn.setAttribute("aria-label", "Toggle language");
    function render(lang) { btn.textContent = lang === "en" ? "FR" : "EN"; }
    render(initial);
    btn.addEventListener("click", function () {
      var current = localStorage.getItem(STORAGE_KEY) || "fr";
      var next = current === "en" ? "fr" : "en";
      localStorage.setItem(STORAGE_KEY, next);
      applyLanguage(next);
      render(next);
    });
    var slot = document.querySelector(".epopee-js-lang-slot");
    if (slot) {
      slot.appendChild(btn);
    } else {
      document.body.appendChild(btn);
    }
  }

  function init() {
    var lang = localStorage.getItem(STORAGE_KEY) || "fr";
    if (lang === "en") applyLanguage("en");
    buildToggle(lang);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
